module.exports = __webpack_public_path__ + "img/home-contact-m.1042e28a.png";